import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import { useAuthStore } from './store/auth-store';
import { useUIStore } from './store/ui-store';
import { Dashboard } from './components/Dashboard';
import { BoardView } from './components/BoardView';
import { ListView } from './components/ListView';
import { Settings } from './components/Settings';
import { Layout } from './components/Layout';
import { TimeTracking } from './components/TimeTracking';
import { ReportsView } from './components/ReportsView';
import { ChartsView } from './components/ChartsView';
import { LoginPage } from './pages/LoginPage';
import { RegisterPage } from './pages/RegisterPage';
import { ProfilePage } from './pages/ProfilePage';
import { MyTasks } from './pages/MyTasks';
import { ActivityFeed } from './pages/ActivityFeed';
import { AdminUsers } from './pages/AdminUsers';
import { AdminProjects } from './pages/AdminProjects';
import { AdminDashboard } from './pages/AdminDashboard';
import { applyDocumentLocale } from './utils/locale';
import { OverviewEditor } from './components/OverviewEditor';
import { TeamManagement } from './components/TeamManagement';
import { ChangeLogView } from './components/ChangeLogView';
import i18n from './i18n';
function ProtectedRoute({ children }) {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
function AdminRoute({ children }) {
    const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
    const user = useAuthStore((s) => s.user);
    const [hydrated, setHydrated] = useState(false);
    useEffect(() => {
        setHydrated(true);
    }, []);
    if (!hydrated) {
        return _jsx("div", { className: "flex h-screen items-center justify-center", children: "Loading..." });
    }
    if (!isAuthenticated) {
        return _jsx(Navigate, { to: "/login", replace: true });
    }
    const adminRoles = ['admin', 'UserAdmin', 'UA', 'Administrator', 'ADMIN'];
    const isAdmin = user && adminRoles.includes(user.role);
    if (!isAdmin) {
        return _jsx(Navigate, { to: "/", replace: true });
    }
    return _jsx(_Fragment, { children: children });
}
function App() {
    const locale = useUIStore((state) => state.locale);
    const theme = useUIStore((state) => state.theme);
    useEffect(() => {
        applyDocumentLocale(locale);
        i18n.changeLanguage(locale);
    }, [locale]);
    useEffect(() => {
        document.documentElement.setAttribute('data-theme', theme);
    }, [theme]);
    return (_jsx(BrowserRouter, { children: _jsxs(Routes, { children: [_jsx(Route, { path: "/login", element: _jsx(LoginPage, {}) }), _jsx(Route, { path: "/register", element: _jsx(RegisterPage, {}) }), _jsxs(Route, { path: "/", element: _jsx(ProtectedRoute, { children: _jsx(Layout, {}) }), children: [_jsx(Route, { index: true, element: _jsx(Dashboard, {}) }), _jsx(Route, { path: "my-tasks", element: _jsx(MyTasks, {}) }), _jsx(Route, { path: "activity", element: _jsx(ActivityFeed, {}) }), _jsx(Route, { path: "board/:projectId", element: _jsx(BoardView, {}) }), _jsx(Route, { path: "list/:projectId", element: _jsx(ListView, {}) }), _jsx(Route, { path: "overview/:projectId", element: _jsx(OverviewEditor, {}) }), _jsx(Route, { path: "team/:projectId", element: _jsx(TeamManagement, {}) }), _jsx(Route, { path: "time/:projectId", element: _jsx(TimeTracking, {}) }), _jsx(Route, { path: "reports/:projectId", element: _jsx(ReportsView, {}) }), _jsx(Route, { path: "charts/:projectId", element: _jsx(ChartsView, {}) }), _jsx(Route, { path: "changelog/:projectId", element: _jsx(ChangeLogView, {}) }), _jsx(Route, { path: "profile", element: _jsx(ProfilePage, {}) }), _jsx(Route, { path: "settings", element: _jsx(Settings, {}) })] }), _jsxs(Route, { element: _jsx(AdminRoute, { children: _jsx(Layout, {}) }), children: [_jsx(Route, { path: "/admin", element: _jsx(AdminDashboard, {}) }), _jsx(Route, { path: "/admin/users", element: _jsx(AdminUsers, {}) }), _jsx(Route, { path: "/admin/projects", element: _jsx(AdminProjects, {}) })] })] }) }));
}
export default App;
//# sourceMappingURL=App.js.map